import { render, staticRenderFns } from "./PartnersUsPage.vue?vue&type=template&id=86c8d44a&scoped=true&"
import script from "./PartnersUsPage.vue?vue&type=script&lang=js&"
export * from "./PartnersUsPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersUsPage.vue?vue&type=style&index=0&id=86c8d44a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c8d44a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PartnersUsHeader: require('/var/www/app/components/partners/partnersUs/partnersUsHeader.vue').default,PartnersUsBenefits: require('/var/www/app/components/partners/partnersUs/partnersUsBenefits.vue').default,BaseSponsorScroll: require('/var/www/app/components/base/BaseSponsorScroll.vue').default})
